import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShield: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconShield"><Path d="M20.5 5.25L12 2.5L3.5 5.25V11.9123C3.5 16.8848 8 19.5 12 21.6579C16 19.5 20.5 16.8848 20.5 11.9123V5.25Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconShield;
